import { validate } from "email-validator";

export function isEmail(value: string) {
  return validate(value);
}
